import React, { useState } from "react";
import { TextField } from "@mui/material";
import { Button } from "antd";
import { TfiReload } from "react-icons/tfi";
import SingleCategoryCard from "../../../components/utility/SingleCategoryCard";
import { useSelector } from "react-redux";

const CategoryList = () => {
  const { category_all } = useSelector((store) => store.category);
  return (
    <>
      <div className="page_header">
        <h4>Categories</h4>
      </div>

      <div className="cat_list_header">
        <div className="cat_search_box">
          <TextField
            id="custom-input"
            placeholder="search"
            variant="outlined"
            autocomplete="off"
            size="small"
            className="input_container"
            InputProps={{
              style: {
                // backgroundColor: "#ffe6e6",
                // border: "1px solid red",
              },
            }}
            FormHelperTextProps={{
              style: {
                marginTop: "0vh",
              },
            }}
          />
        </div>
        <div className="cat_lis_ad_rs">
          <Button icon={<TfiReload />} iconPosition="start">
            Refresh
          </Button>
          <Button className="confirm_btn sub_padding">Add Category</Button>
        </div>
      </div>

      <div className="catlis_main">
        {category_all &&
          category_all.map((data, index) => (
            <SingleCategoryCard data={data} key={index} />
          ))}
      </div>
    </>
  );
};

export default CategoryList;
